import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import 'primeicons/primeicons.css'; // Import Prime Icons CSS
import { createPinia } from 'pinia';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import axios from 'axios';

import router from './router'
import store from '@/store/store'
import apiClient, { logApiConfig } from '@/config/apiClient.js'
import config from '@/config/index.js'

const pinia = createPinia();
const app = createApp(App)

app.use(pinia);
app.use(router)
app.use(store)
app.use(VueTelInput);

// ===== API Configuration =====
// Set global axios instance and log configuration in development
if (config.isDevelopment) {
  logApiConfig()
}

// ===== CSRF Token Interceptor (LEGACY - handled by apiClient now) =====
// Kept for backward compatibility, but main logic is in apiClient.js
const getCookie = (name) => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};

// Add CSRF token to request headers for state-changing methods
axios.interceptors.request.use((config) => {
  const methods = ['post', 'put', 'patch', 'delete'];
  if (methods.includes(config.method?.toLowerCase())) {
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken;
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

app.mount('#app')

// Load Google Maps API with async attribute for best performance
const script = document.createElement('script')
script.src = `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_GOOGLE_PLACES_API_KEY}&libraries=places,maps,marker&loading=async`
script.async = true
script.defer = true
document.head.appendChild(script)